import { render } from "./Footer.vue?vue&type=template&id=82694b32&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=82694b32&scoped=true&lang=css"

import exportComponent from "/Users/don/phpStorm/qr-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82694b32"]])

export default __exports__